import { actionNames } from "constant/index";
const mapDispatchToProps = (dispatch) => ({
  CERTIFICACIONDEGOCEDESUSDERECHOSPOLITICOS_SET_DATA: (data) =>
    dispatch({
      type: actionNames.CERTIFICACIONDEGOCEDESUSDERECHOSPOLITICOS_SET_DATA,
      state: { data: data },
    }),
  SET_CURRENT_USER: (currentUser) =>
    dispatch({
      type: actionNames.SET_CURRENT_USER,
      state: { currentUser: currentUser },
    }),
});
export default mapDispatchToProps;
